import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useLogout } from '@/v2/hooks/auth/useAuthentication'
import IconMenu from '@/v2/components/common/IconMenu'
import MenuIcon from '@mui/icons-material/Menu'
import { useSnackbarContext } from '@/v2/contexts/SnackbarContext'
import { useAuthContext } from '@/v2/contexts/AuthContext'
import { useUser } from '@/v2/hooks/useUser'

const SettingsMenu = () => {
  const { setIsLoggedIn } = useAuthContext()
  const navigate = useNavigate()
  const { logout } = useLogout()
  const { onOpenSnackbar } = useSnackbarContext()
  const { user } = useUser()
  const isAdmin = user?.admin || false

  const handleLogout = () => {
    logout(null, {
      onSuccess: () => {
        setIsLoggedIn(false)
        navigate('/v2/login')
      },
      onError: error => {
        onOpenSnackbar(`${error}`, 'error')
      },
    })
  }

  const adminOptions = [
    // { label: 'Settings', href: '/settings' },
    { label: 'Settings', href: '/v2/settings' },
    { label: 'Sign out', onClick: handleLogout },
  ]

  const userOptions = [{ label: 'Sign out', onClick: handleLogout }]

  return (
    <IconMenu
      icon={<MenuIcon />}
      title="Settings"
      hovercolor="secondary"
      bordercolor="topbarIconBorder"
      aria-label="Settings"
      options={isAdmin ? adminOptions : userOptions}
    />
  )
}

export default SettingsMenu
